<template>
  <el-drawer
    title="批量导入数据"
    :modal-append-to-body="false"
    append-to-body
    :visible.sync="dialogVisible"
    :wrapperClosable="false"
    custom-class="widthCommon"
    :before-close="handleClose"
  >
    <el-card style="padding: 0 12px">
      <el-button v-if="downloadTemplate" type="primary" size="small" @click="downLoad">{{ downLoadText }}</el-button>
      <div class="lineOne">
        <span class="select">{{ downloadTemplate ? '上传文件' : '选择文件' }}</span>
        <el-upload
          v-show="true"
          :action="uploadApi"
          ref="uploadNw"
          :file-list="fileList"
          name="file"
          :limit="1"
          :accept="`${accept}`"
          :http-request="handleFileUpload1"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :on-progress="handleProgres"
          :auto-upload="false"
          :show-file-list="false"
          class="upload"
        >
          <template v-if="!fileShow">
            <img slot="trigger" :src="imgUrlNew" alt="" class="plus" />
            <span slot="trigger" class="text">点击选择文件</span>
          </template>
          <template v-else>
            <img slot="trigger" :src="imgUrlist" alt="" class="plus" />
            <div slot="trigger" class="xlsList">
              <div class="xlsList_top">
                <div class="xlsList_top_l">{{ fileList[0].name }}</div>
                <div class="xlsList_top_r" @click="clear()">重新选择</div>
              </div>
              <div class="xlsList_base">
                <el-progress :percentage="percentage" :show-text="false"></el-progress>
              </div>
            </div>
          </template>
        </el-upload>
      </div>
      <el-button style="margin-top: 20px" :loading="isLoading" type="primary" :class="{ disabled: upShow == 0 }" @click="handleFileUpload">
        {{ downloadTemplate ? '上传' : '导入' }}
      </el-button>
      <!-- 成功or失败 -->
      <div class="succ" v-if="isImport == 1">{{ downloadTemplate ? '文件上传成功！请导入文件' : '文件导入成功！' }}</div>
      <div class="fail" v-else-if="isImport == 0">
        <div class="fail_top">{{ downloadTemplate ? '文件上传失败！' : '文件导入失败！' }}</div>
        <div class="fail_center">
          <div class="fail_center_l">失败原因:</div>
          <div class="fail_center_r">
            <div style="margin-bottom: 16px" v-for="item in errorResultList" :key="item">{{ item }}</div>
          </div>
        </div>
      </div>
      <div v-if="showTips" class="check">
        <span class="select">{{ tips + '：' }}</span>
        <el-radio v-model="radio" :label="true">自动创建</el-radio>
        <el-radio v-model="radio" :label="false">错误提示</el-radio>
      </div>
    </el-card>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="取消" :myFunction="resetForm" />

      <ELButton v-if="downloadTemplate" size="small" describe="导入" isAsync :myFunction="submitForm" :class="{ disabled: dwShow == 0 }" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import axios from 'axios'
import { baseURL } from '@/api/getFile'
import { getToken } from '@/utils/auth'
import { excelBeginImport } from '@/api/device.js'
export default {
  props: {
    level: {
      type: String,
      default: '',
    },
    downloadTemplate: {
      type: Boolean,
      default: true,
    },
    uploadApiUrl: {
      type: String,
      default: '/oa/excelRecordIns',
    },
    downLoadText: {
      type: String,
      default: '下载模板',
    },
    downLoadApiUrl: {
      type: String,
      default: '',
    },
    showTips: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: '',
    },
    fileType: {
      type: String,
      require: '.xlsx',
    },
    accept: {
      type: String,
      require: '.xlsx,.xls',
    },
    fileTypeName: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      radio: false,
      fileList: [],
      imgUrl: require('@/assets/image/add.png'),
      imgUrlNew: require('@/assets/image/uploadFilled.png'),
      imgUrlist: require('@/assets/image/xlxsImg.png'),
      dialogVisible: false,
      file: '',
      isLoading: false,
      fileShow: false,
      percentage: 0,
      upShow: 0,
      dwShow: 0,
      isImport: 2,
      errorResultList: [],
      excelRecordId: '',
    }
  },
  computed: {
    uploadApi() {
      return baseURL + this.uploadApiUrl
    },
    downLoadApi() {
      return `${baseURL + this.downLoadApiUrl}?token=${getToken()}`
    },
  },
  methods: {
    handleClose() {
      this.handleRemove()
    },
    resetForm() {
      this.handleRemove()
    },
    // 下载模板
    async downLoad() {
      axios({
        url: this.downLoadApi,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
        const disposition = res.headers['content-disposition'].replace(/\;/g, '')
        const fileName = decodeURIComponent(disposition.substring(disposition.indexOf('=') + 1), 'UTF-8')
        const suffix = fileName.replace(/\"/g, '').split('.')[1]
        const link = document.createElement('a')
        const blob = new Blob([res.data])
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', `${this.level}.${suffix || 'xlsx'}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    clear() {
      //
      this.upShow = 0
      this.fileShow = false
      this.dwShow = 0
      this.isImport = 2
      this.percentage = 0
      this.$refs.uploadNw.clearFiles()
    },
    //自定义上传校验
    handleFileUpload() {
      if (!this.fileShow) return false
      this.$refs.uploadNw.submit()
    },
    handleFileUpload1() {
      this.isLoading = true
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('token', getToken())
      if (this.showTips) formData.append('autoCreateParent', this.radio)
      formData.append('fileName', this.fileType)
      formData.append('fileTypeName', this.fileTypeName)
      axios({
        url: this.uploadApi,
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(res => {
          if ([4, 12].includes(res.data.errCode)) {
            if (res.data.errCode == 4) this.errorResultList = ['文件格式不合法']
            if (res.data.errCode == 12) this.errorResultList = [res.data.errMsg]
            this.percentage = 100
            this.isImport = 0
            this.dwShow = 0
          } else {
            this.percentage = 100
            if (res.data.data.isImport !== null && res.data.data.isImport !== undefined) this.isImport = res.data.data.isImport
            if (res.data.data.isSuccess !== null && res.data.data.isSuccess !== undefined) this.isImport = res.data.data.isSuccess ? 1 : 0
            this.errorResultList = res.data.data.errorResultList
            this.excelRecordId = res.data.data.excelRecordId
            if (this.isImport) {
              this.dwShow = 1
            } else {
              this.dwShow = 0
            }
          }

          //
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    //导入
    async submitForm() {
      if (this.dwShow == 0) return false
      const { data: res } = await excelBeginImport({ id: this.excelRecordId })
      this.handleClose()
      this.$store.dispatch('tagsView/uprecordDraw', true)
    },
    handleRemove() {
      this.$options.data()
      this.isLoading = false
      this.percentage = 0
      this.upShow = 0
      this.dwShow = 0
      this.isImport = 2
      this.file = ''
      this.fileList = []
      this.dialogVisible = false
      this.fileShow = false
    },
    handleChange(file, fileList) {
      this.fileShow = true
      this.fileList = fileList
      this.file = file.raw
      this.upShow = 1
    },
    handleProgres(event, file, fileList) {
      this.percentage = parseInt(event.percent)
      if (this.percentage >= 100) {
        this.percentage = 100
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.upBtn {
  margin-left: 30px;
  border-radius: 8px;
  background: #3276dd;
  // padding: 14px 21px;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.check {
  padding-bottom: 20px;
  font-size: 14px;
  color: #3f3f3f;
}
.lineOne {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  flex-direction: column;
  .select {
    font-size: 14px;
    font-weight: 500;
    color: #3d3d3d;
    padding-right: 40px;
    padding-top: 22px;
    margin-bottom: 24px;
  }
  .upload {
    flex: 1;
    height: 98px;

    .plus {
      width: 58px;
      height: 58px;
      padding-bottom: 2px;
      margin-right: 16px;
    }
    .text {
      font-size: 14px;
      color: #cacaca;
    }
  }
}
.btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .el-upload {
  width: 100% !important;
  border: 1px solid #b2b2b2;
  border-radius: 8px;
  display: flex;
  height: 100%;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  // justify-content: flex-start;
  align-items: center;
  .el-upload-list {
    text-align: left;
  }
}
::v-deep .el-dialog {
  border-radius: 12px;
}
::v-deep .el-dialog__header {
  border-radius: 12px 12px 0 0;
  background: #f7f7f7;
  font-size: 18px;
  color: #3f3f3f;
  font-weight: bold;
  padding: 22px 17px;
  .el-dialog__close {
    color: #1a1a1a;
  }
}
::v-deep .el-dialog__body {
  padding: 7% 11% !important;
  text-align: center !important;
  // .lineOne {
  //   height: 120px;
  // }
}

.xlsList {
  width: 100%;
  display: flex;
  flex-direction: column;
  // display: inline-block;
  .xlsList_top {
    //  display: inline-block;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .xlsList_top_l {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
    }
    .xlsList_top_r {
      font-size: 12px;
      color: #31a8ff;
    }
  }
  .xlsList_base {
    // display: inline-block;
    width: 80%;
    margin-top: 16px;
  }
}
.disabled {
  background: #e7e7e7 !important;
  color: #a3a6ad !important;
}
.succ {
  margin-top: 24px;
  border-radius: 4px;
  width: 100%;
  height: 66px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  color: #48a460;
  font-size: 18px;
  font-weight: 500;
  background-color: #ecf9ef;
}
.fail {
  width: 100%;
  flex-grow: 1;
  height: auto;
  position: relative;
  margin-top: 24px;
  background-color: #fff1f1;
  color: #ff0000;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 4px;
  .fail_top {
    font-size: 18px;
    font-weight: 500;
  }
  .fail_center {
    margin-top: 18px;
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    .fail_center_l {
      margin-right: 5px;
      width: 85px;
    }
    .fail_center_r {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
